import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ResetPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const { resetPassword } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess(false);
    
    if (!email) {
      setError('Please enter your email address');
      return;
    }
    
    setLoading(true);
    
    try {
      await resetPassword(email);
      setSuccess(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to reset password. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      width: '100%',
      minHeight: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      background: '#F5F7FA'
    }}>
      <div style={{
        width: '400px',
        background: 'white',
        borderRadius: '12px',
        padding: '30px',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)'
      }}>
        <div style={{textAlign: 'center', marginBottom: '30px'}}>
          <h1 style={{
            fontSize: '28px',
            color: '#F04915',
            fontFamily: 'Outfit, sans-serif',
            fontWeight: '700'
          }}>
            Reset Password
          </h1>
          <p style={{color: '#798AA3', fontSize: '16px', fontFamily: 'Outfit, sans-serif'}}>
            Enter your email to receive a password reset link
          </p>
        </div>

        {error && (
          <div style={{
            padding: '12px',
            background: '#FFF0F0',
            color: '#CF1717',
            borderRadius: '8px',
            marginBottom: '20px',
            fontSize: '14px',
            fontFamily: 'Outfit, sans-serif'
          }}>
            {error}
          </div>
        )}

        {success ? (
          <div style={{
            padding: '12px',
            background: '#F0FFF4',
            color: '#176837',
            borderRadius: '8px',
            marginBottom: '20px',
            fontSize: '14px',
            fontFamily: 'Outfit, sans-serif'
          }}>
            Password reset link has been sent to your email address. Please check your inbox.
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div style={{marginBottom: '20px'}}>
              <label style={{
                display: 'block',
                marginBottom: '8px',
                color: '#131A1A',
                fontSize: '16px',
                fontFamily: 'Outfit, sans-serif',
                fontWeight: '500'
              }}>
                Email
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                style={{
                  width: '100%',
                  height: '48px',
                  padding: '0 15px',
                  borderRadius: '8px',
                  border: '1px solid #C5D0DE',
                  fontSize: '16px',
                  fontFamily: 'Outfit, sans-serif'
                }}
                placeholder="Enter your email"
              />
            </div>
            
            <button 
              type="submit" 
              disabled={loading}
              style={{
                width: '100%',
                height: '48px',
                background: '#F04915',
                border: 'none',
                borderRadius: '8px',
                color: 'white',
                fontSize: '16px',
                fontFamily: 'Outfit, sans-serif',
                fontWeight: '500',
                cursor: loading ? 'not-allowed' : 'pointer',
                opacity: loading ? 0.7 : 1,
                marginBottom: '20px'
              }}
            >
              {loading ? 'Sending...' : 'Reset Password'}
            </button>
          </form>
        )}
        
        <div style={{
          textAlign: 'center',
          marginTop: '20px',
          color: '#798AA3',
          fontSize: '14px',
          fontFamily: 'Outfit, sans-serif'
        }}>
          <Link to="/login" style={{color: '#F04915', fontWeight: '500', textDecoration: 'none'}}>
            Back to Sign In
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;